var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoiTuongThamGia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7071 9.2778C11.6651 9.2778 10.6784 9.48577 9.84854 9.82937C12.7624 10.6612 14.8187 12.6415 14.8648 14.9472C16.3771 14.7483 18 14.1967 18 12.6595C18 10.824 15.5748 9.2778 12.7071 9.2778Z",
    fill: "#FB7800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6794 7.97576H12.7071C14.6712 7.97576 16.2665 6.41148 16.2665 4.48552C16.2665 2.55955 14.6712 0.99527 12.7071 0.99527C12.3198 0.99527 11.951 1.05856 11.6006 1.16707C12.2368 2.08936 12.6057 3.20154 12.6057 4.3951C12.6057 5.65195 12.1907 6.81838 11.4899 7.7678C11.8588 7.90343 12.2645 7.97576 12.6794 7.97576Z",
    fill: "#FB7800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.73971 10.76C3.08631 10.76 0 12.7176 0 15.0351C0 17.6926 3.84613 18 6.73971 18C8.40689 18 13.4794 18 13.4794 15.017C13.4794 12.7095 10.3931 10.76 6.73971 10.76Z",
    fill: "#FB7800"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.71089 8.79705H6.73855C9.21257 8.79705 11.2246 6.82407 11.2246 4.39898C11.2246 1.97298 9.21257 0 6.73855 0C4.26637 0 2.25432 1.97298 2.25432 4.39717C2.24971 5.56812 2.70984 6.67035 3.55173 7.50132C4.39362 8.33229 5.51491 8.79253 6.71089 8.79705Z",
    fill: "#FB7800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoiTuongThamGia);
export default __webpack_public_path__ + "static/media/doi-tuong-tham-gia.66283f95b4ff0b3fa2add935b452a0f2.svg";
export { ForwardRef as ReactComponent };